export default "__VITE_ASSET__rDwphEbV__"